// extracted by mini-css-extract-plugin
export default {"label":"k2_mC6","label--disabled":"SI59Ts","label__text":"dMOIjQ"};